import {
	forgotPassword,
	loginUser,
	refreshToken,
	resetPassword,
	registerAuditLog,
} from "@/services/users.service";

export default {
	namespaced: true,
	state: {
		userRequestStatus: "init",
		user: {},
	},
	getters: {
		// STATUS
		getUserResquestStatus(state) {
			return state.userRequestStatus;
		},
		getUserDetails(state) {
			return state.user;
		},
		getUserFromStorage() {
			return JSON.parse(localStorage.getItem("user"));
		},
	},
	mutations: {
		// STATUS
		USER_STATUS(state, value) {
			state.userRequestStatus = value;
		},
		CLEAR_LOGGED_USER() {
			localStorage.clear();
		},
		SET_USER(state, user) {
			state.user = user;
		},
	},
	actions: {
		async doLogout({ commit }) {
			commit("CLEAR_LOGGED_USER", "clear");
			var cookies = document.cookie.split(";");

			for (var i = 0; i < cookies.length; i++) {
				var cookie = cookies[i];
				var pos = cookie.indexOf("=");
				var nome = pos > -1 ? cookie.substr(0, pos) : cookie;
				document.cookie =
					nome + "=;expires=Thu, 01 Jan 1970 00:00:00 GMT";
			}
			window.location.href = "/login";
		},
		async doForgotPassword({ commit }, params) {
			commit("USER_STATUS", "pending");
			try {
				const { data } = await forgotPassword(params);
				commit("USER_STATUS", "init");
				return data;
			} catch (error) {
				commit("USER_STATUS", "init");
				throw error;
			}
		},
		async doResetPassword({ commit }, params) {
			commit("USER_STATUS", "pending");
			try {
				const { data } = await resetPassword(params);
				commit("USER_STATUS", "init");
				return data;
			} catch (error) {
				commit("USER_STATUS", "init");
				throw error;
			}
		},
		async loginUser({ commit }, params) {
			commit("USER_STATUS", "pending");
			try {
				const { data } = await loginUser(params);
				localStorage.setItem("user", JSON.stringify(data.user));
				localStorage.setItem("refreshToken", data.refreshToken);
				localStorage.setItem("token", data.idToken);
				commit("USER_STATUS", "init");
				commit("SET_USER", data.user);
				return data;
			} catch (error) {
				commit("USER_STATUS", "init");
				throw error;
			}
		},
		async refreshToken({ commit }, payload) {
			commit("USER_STATUS", "pending");
			try {
				const { data } = await refreshToken(payload);
				if (data.user)
					localStorage.setItem("user", JSON.stringify(data.user));
				localStorage.setItem("refreshToken", data.refreshToken);
				localStorage.setItem("token", data.idToken);
				commit("USER_STATUS", "init");
				setTimeout(() => {
					window.location.reload();
				}, 1000);
				return data;
			} catch (error) {
				commit("USER_STATUS", "init");
				throw error;
			}
		},
		// eslint-disable-next-line no-unused-vars
		createAuditLog({ commit }, params) {
			registerAuditLog(params);
		},
	},
};
